var pt_config_menu = {
        sel: {
            sidebarDrawerContainer: "#sidebar-menu .Drawer__Container",
            headerCloseBtn: "header button.Header__Icon--close",
            pt301CloseBtn: "button.pt301_closeBtn",
            collapsibleButton: "#sidebar-menu .Drawer__Container .SidebarMenu__Nav .Collapsible>button.Collapsible__Button",
            pt301MainMenuOpen: "pt301_mainMenu_open"
    }
  };
    var drawerContainer = document.querySelector(pt_config_menu.sel.sidebarDrawerContainer);
    var collapsibleMenuBtns = document.querySelectorAll(pt_config_menu.sel.collapsibleButton);
       collapsibleMenuBtns.forEach(function(btn) {
            btn.addEventListener("click", function(e) {
                "true" === e.currentTarget.getAttribute("aria-expanded") ? (drawerContainer.classList.contains(pt_config_menu.sel.pt301MainMenuOpen) && drawerContainer.classList.remove(pt_config_menu.sel.pt301MainMenuOpen), 
                e.currentTarget.parentElement.classList.remove(pt_config_menu.sel.pt301MainMenuOpen)) : (drawerContainer.classList.contains(pt_config_menu.sel.pt301MainMenuOpen) || drawerContainer.classList.add(pt_config_menu.sel.pt301MainMenuOpen), 
                e.currentTarget.parentElement.classList.add(pt_config_menu.sel.pt301MainMenuOpen));
            });
        });

        document.addEventListener('DOMContentLoaded', function () {
  const topBlocks = document.querySelectorAll('.pt_451_top_block');
  const collapsibles = document.querySelectorAll('.Collapsible');

  topBlocks.forEach(block => {
    block.addEventListener('click', function () {
      const target = this.getAttribute('data-target');

      // Highlight active top button
      topBlocks.forEach(b => b.classList.remove('pt_451_active'));
      this.classList.add('pt_451_active');

      collapsibles.forEach(collapsible => {
        const section = collapsible.getAttribute('data-section');
        const inner = collapsible.querySelector('.Collapsible__Inner');
         const button = collapsible.querySelector('.Collapsible__Button');

        if (section === target) {
          collapsible.classList.add('pt301_mainMenu_open');
          // ✅ Apply styles & aria-expanded
          if (inner) {
            inner.style.overflow = 'visible';
            inner.style.height = '297px';
          }
          if (button) {
            button.setAttribute('aria-expanded', 'true');
          }
        } else {
          collapsible.classList.remove('pt301_mainMenu_open');
          // Reset styles & aria-expanded
          if (inner) {
            inner.style.overflow = '';
            inner.style.height = '';
          }
          if (button) {
            button.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  });

  // Initialize default active section
  const activeBlock = document.querySelector('.pt_451_top_block.pt_451_active');
  if (activeBlock) {
    const activeTarget = activeBlock.getAttribute('data-target');
    collapsibles.forEach(collapsible => {
      const section = collapsible.getAttribute('data-section');
      const inner = collapsible.querySelector('.Collapsible__Inner');
      const button = collapsible.querySelector('.Collapsible__Button');

      if (section === activeTarget) {
        if (inner) {
          collapsible.classList.add('pt301_mainMenu_open');
          inner.style.overflow = 'visible';
          inner.style.height = '297px';
        }
        if (button) {
          button.setAttribute('aria-expanded', 'true');
        }
      } else {
        collapsible.classList.remove('pt301_mainMenu_open');
        if (inner) {
          inner.setAttribute('aria-expanded', 'false');
        }
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }
});
